export default __webpack_public_path__ + "static/media/document-upload.bd7c4647.svg";